import React, { useState } from "react";

const faqs = [
  {
    question: "How long does a typical website take to build?",
    answer: "Most projects take 4–12 weeks, depending on features, integrations, and complexity.",
  },
  {
    question: "Do you work with startups or only large businesses?",
    answer:
      "We serve all businesses, from innovative startups to large enterprises, offering scalable, cost-effective solutions tailored to your needs.",
  },
  {
    question: "Do you make responsive websites that work on mobile phones?",
    answer:
      "Yes. Every site we build is SEO-optimized from day one, covering speed, structure, mobile-first design, and metadata management.",
  },
  {
    question: "Can you redesign my current website?",
    answer:
      "Absolutely. We specialize in redesigning websites while preserving SEO and modernizing the design and performance.",
  },
  {
    question: "Do you offer ecommerce support for existing stores?",
    answer:
      "Yes, we provide ongoing support for Shopify, Magento, and WooCommerce stores, including performance optimization, theme updates, and store enhancements.",
  },
];

const Section9 = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="w-full SectionWebsiteFAQs py-[30px] md:py-[50px]">
      <div className="w-[90%] md:w-[61%] mx-auto text-center">
        <h2 className="leading-[29px] md:leading-[41px] text-[24px] md:text-[30px] text-[#151515] font-bold mb-10">
          FAQs about Website Development Services in New York
        </h2>
      </div>

      <div className="w-full md:w-[784px] mx-auto p-5 md:p-[2%] space-y-4">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE]"
          >
            <div
              onClick={() => toggleFAQ(index)}
              className="question text-[#444444] cursor-pointer flex justify-between items-center"
            >
              {faq.question}
              <b className="text-[40px] text-[#DA2128] font-[300] leading-none">
                {openIndex === index ? "-" : "+"}
              </b>
            </div>

            {openIndex === index && (
              <div className="answer text-[#444444] mt-3">
                <p className="mb-5">{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Divider Line */}
      <div className="line mb-[55px] md:mb-[4%] mt-[1%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
};

export default Section9;
